import dayjs from "dayjs"

// Converts null to undefined
const convertDate = (connectDate: string | null) => (connectDate ? connectDate : undefined)

// Do nothing with the from date
export const convertFromDate = convertDate

// Add one day to the "to"-Date for an "inclusive" filter
export const convertToDate = (connectDate: string | null) => (connectDate ? adjustToDate(connectDate) : undefined)

// Adds one day to the date
export const adjustToDate = (connectDateString: string) => {
  const connectDate = new Date(connectDateString)
  const adjustedDate = dayjs(connectDate).add(23, "hour").add(59, "minute").add(59, "second")
  return adjustedDate.toString()
}

// Format the date similar to the Connect style
export const formatDateAsConnect = (date: string) => dayjs(date).format("MMM DD YYYY hh:mm a")

// Format the date similar to the Connect style, do not show time-of-day
export const formatDateOnlyAsConnect = (date: string) => dayjs(date).format("MMM DD YYYY")
